import faviconSVG from './assets/favicon.svg';
import iosIcon180 from './assets/ios-icon-180.png';
// fallback icons for old browsers
import favicon16 from './assets/favicon-16.png';
import favicon32 from './assets/favicon-32.png';

function Favicon() {
  return (
    <>
      <link rel="icon" href={ faviconSVG.src } type="image/svg+xml" />
      <link rel="icon" href={ favicon16.src } sizes="16x16" type="image/png" />
      <link rel="icon" href={ favicon32.src } sizes="32x32" type="image/png" />
      <link rel="apple-touch-icon" href={ iosIcon180.src } sizes="180x180" />
    </>
  );
}

export default Favicon;
